module.exports = __webpack_public_path__ + "img/no-data.31f4f44a.png";